import {
	FETCH_EVENT_POINT,
	DELETE_EVENT_POINT,
	UPDATE_EVENT_POINT,
	CREATE_EVENT_POINT,
	FETCH_ATTENDEE_POINT,
	CREATE_ATTENDEE_POINT,
	UPDATE_ATTENDEE_POINT,
	DELETE_ATTENDEE_POINT,
} from '../actions/actionTypes';

const preState = { eventPoint: null, attendeePoints: {} };

const pointsReducer = (state = preState, action) => {
	Object.freeze(state);
	const stateDup = { ...state };
	const { type, eventPoint, attendeePointsByID, attendeePoint } = action;
	const { attendeePoints } = stateDup;
	const attendeeID = attendeePoint && attendeePoint.attendee_id;

	switch (type) {
		case FETCH_EVENT_POINT:
			return { ...stateDup, eventPoint };
		case DELETE_EVENT_POINT:
			stateDup.eventPoint = {};
			return stateDup;
		case UPDATE_EVENT_POINT:
			return { ...stateDup, eventPoint };
		case CREATE_EVENT_POINT:
			return { ...stateDup, eventPoint };
		case CREATE_ATTENDEE_POINT:
			const newState = JSON.parse(JSON.stringify(stateDup));
			newState.attendeePoints[attendeeID].push(attendeePoint);
			return { ...newState };
		case UPDATE_ATTENDEE_POINT:
			const index = stateDup.attendeePoints[attendeeID].findIndex(
				point => point.id === attendeePoint.id
			);
			const updatedPointsArray = [
				...stateDup.attendeePoints[attendeeID].slice(0, index),
				attendeePoint,
				...stateDup.attendeePoints[attendeeID].slice(index + 1),
			];
			const updatedState = {
				...stateDup,
				attendeePoints: { ...stateDup.attendeePoints, [attendeeID]: updatedPointsArray },
			};
			return updatedState;
		case DELETE_ATTENDEE_POINT:
			const filteredAttendeePoints = stateDup.attendeePoints[attendeeID].filter(
				point => point.id !== attendeePoint.id
			);
			return {
				...stateDup,
				attendeePoints: { ...stateDup.attendeePoints, [attendeeID]: filteredAttendeePoints },
			};
		case FETCH_ATTENDEE_POINT:
			return { ...stateDup, attendeePoints: { ...attendeePoints, ...attendeePointsByID } };
		default:
			return stateDup;
	}
};

export default pointsReducer;
